import { ReactElement } from 'react';
import { Alert, Input } from '@sc/shared-ui';
import { SubscriptionType } from '@sc/graphql';
import { maxQueryMultiplierBySubscription } from '@sc/stripe/pricing';
import { useUser } from '../providers/users';

export const SettingsUsageLimitsTab = (): ReactElement => {
  const { user } = useUser();

  const subscription = user.company.subscription;
  const isEnteprise = subscription?.type === SubscriptionType.enterprise;

  const maxMultiplier = subscription
    ? maxQueryMultiplierBySubscription[subscription.type]
    : 1;

  const maxMultiplierLabel = Number.isFinite(maxMultiplier)
    ? `${maxMultiplier}x`
    : 'Unlimited';

  return (
    <>
      {isEnteprise && (
        <div className="p-5 max-w-md">
          <Alert
            type="low-priority"
            message="Limits on your Scale subscription are managed through your account manager."
          />
        </div>
      )}
      <div className="p-5 max-w-md space-y-5">
        <Input
          label="Max query depth"
          value={maxMultiplierLabel}
          disabled
          helperText="The richest query your knowledge bases can be configured for — each multiple allows another 50,000 tokens and consumes another query. Set automatically by your subscription tier."
          onChange={() => undefined}
        />
      </div>
    </>
  );
};
